import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Box, Flex, Text } from "@chakra-ui/react";

interface IProps {
  title: string;
  icon: React.ReactElement;
  to?: string;
  onClick?: () => void;
}

const MenuItem: React.FC<IProps> = (props) => {
  const { title, icon, to, onClick } = props;

  const location = useLocation();
  const isSelected = to ? location.pathname === to : false;

  return (
    <Flex
      alignItems={"center"}
      role="group"
      borderRadius={"base"}
      bg={isSelected ? "blue.200" : "none"}
      _hover={{ bg: isSelected ? "blue.200" : "neutrals.300" }}
      cursor={"pointer"}
      my={0.5}
      onClick={onClick}
    >
      <Flex flex={"1 1 auto"} alignItems={"center"}>
        <Link to={to ?? "#"} style={{ width: "100%" }}>
          <Flex flex={"1 1 auto"} alignItems={"center"}>
            <Box p={1}>{icon}</Box>
            <Text
              color={"#292A2E"}
              overflow="hidden"
              fontSize={"xs"}
              textOverflow="ellipsis"
            >
              {title}
            </Text>
          </Flex>
        </Link>
      </Flex>
    </Flex>
  );
};

export default MenuItem;
